import { useContext } from "react"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useGetFeatureSettings = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop

		return async () => {
			return await authenticatedFetch(
				`/api/protect/getFeatureSettings?shop=${shop}`,
			)
				.then((res) => res.json())
				.then((json) => json?.featureSettings || null)
		}
	} catch (error) {
		console.error("[useGetFeatureSettings] catched error", error)
	}
}

export const useUpdateFeatureSetting = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state, dispatch } = useContext(GlobalStateContext)
		const shop = state.shop

		return async (fields) => {
			return await authenticatedFetch(
				"/api/protect/updateFeatureSetting",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						shop: shop,
						fields: fields,
					}),
				},
			)
		}
	} catch (error) {
		console.error("[useUpdateFeatureSetting] catched error", error)
	}
}

export const useCheckScriptTag = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop
		const accessToken = state.accessToken

		return async () => {
			return await authenticatedFetch("/api/protect/checkScriptTag", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					shop: shop,
					accessToken: accessToken,
				}),
			})
				.then((res) => res.json())
				.then((json) => json?.scriptTagIsPresent || null)
		}
	} catch (error) {
		console.error("[useCheckScriptTag] catched error", error)
		return () => false
	}
}

export const useCreateScriptTag = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop
		const accessToken = state.accessToken

		return async () => {
			return await authenticatedFetch("/api/protect/createScriptTag", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					shop: shop,
					accessToken: accessToken,
				}),
			})
				.then((res) => res.json())
				.then((json) => {
					return {
						scriptTagId: json?.scriptTagId || null,
						error: json?.error || null,
					}
				})
		}
	} catch (error) {
		console.error("[useCreateScriptTag] catched error", error)
		return () => ({ scriptTagId: null, error: "Unexpected error" })
	}
}

export const useCheckScopes = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop
		const accessToken = state.accessToken

		return async (wantedScopes) => {
			return await authenticatedFetch("/api/protect/checkScopes", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					shop: shop,
					accessToken: accessToken,
					wantedScopes: wantedScopes,
				}),
			})
				.then((res) => res.json())
				.then((json) => {
					return {
						hasNeccessaryScopes: json?.hasNeccessaryScopes || false,
						enabledScopes: json?.enabledScopes || [],
					}
				})
		}
	} catch (error) {
		console.error("[useCheckScopes] catched error", error)
		return {
			hasNeccessaryScopes: false,
			enabledScopes: [],
		}
	}
}

export const useDeleteScriptTag = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop
		const accessToken = state.accessToken

		return async () => {
			return await authenticatedFetch("/api/protect/deleteScriptTag", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					shop: shop,
					accessToken: accessToken,
				}),
			})
				.then((res) => res.json())
				.then((json) => {
					return {
						success: json?.success || false,
						error: json?.error || null,
					}
				})
		}
	} catch (error) {
		console.error("[useDeleteScriptTag] catched error", error)
		return () => ({ success: false, error: "Unexpected error" })
	}
}

export const useDeleteFeatureSettings = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state } = useContext(GlobalStateContext)
		const shop = state.shop
		const accessToken = state.accessToken

		return async () => {
			return await authenticatedFetch(
				"/api/protect/deleteFeatureSettings",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						shop: shop,
						accessToken: accessToken,
					}),
				},
			)
				.then((res) => res.json())
				.then((json) => json?.success || false)
		}
	} catch (error) {
		console.error("[useDeleteFeatureSettings] catched error", error)
		return () => false
	}
}
